// extracted by mini-css-extract-plugin
module.exports = {"itemHeader":"distributionListItemSkeleton_itemHeader__23Inq","title":"distributionListItemSkeleton_title__1Wu2u"};